/* ============================================================
   PRÉSENTOIRBUFFET — JS ANIMATIONS
   Créer un fichier assets/animations.js et y coller ce code.
   Puis dans layout/theme.liquid, juste avant </body>, ajouter :
   <script src="{{ 'animations.js' | asset_url }}" defer></script>
   ============================================================ */

(function () {
  'use strict';

  // Respect des préférences utilisateur
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.pb-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  // ─── SCROLL REVEAL via IntersectionObserver ────────────
  const revealOptions = {
    root: null,
    rootMargin: '0px 0px -80px 0px',
    threshold: 0.08
  };

  const revealObserver = new IntersectionObserver(function (entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target); // Une seule fois
      }
    });
  }, revealOptions);

  function observeReveal() {
    document.querySelectorAll('.pb-reveal:not(.is-visible)').forEach(function (el) {
      revealObserver.observe(el);
    });
  }

  // Observer au load + après chaque changement DOM (sections Shopify dynamiques)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeReveal);
  } else {
    observeReveal();
  }

  // Shopify section reload (éditeur de thème)
  document.addEventListener('shopify:section:load', observeReveal);

  // ─── PARALLAX SUBTIL POUR HEROES ────────────────────────
  const parallaxElements = document.querySelectorAll('[data-pb-parallax]');
  if (parallaxElements.length && !('ontouchstart' in window)) {
    let ticking = false;

    function updateParallax() {
      const scrollY = window.pageYOffset;
      parallaxElements.forEach(function (el) {
        const speed = parseFloat(el.dataset.pbParallax) || 0.3;
        const rect = el.getBoundingClientRect();
        const offset = (scrollY - el.offsetTop) * speed;
        el.style.backgroundPosition = 'center calc(50% + ' + offset + 'px)';
      });
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }, { passive: true });
  }

  // ─── HEADER STICKY AVEC EFFET AU SCROLL ─────────────────
  const header = document.querySelector('.header-wrapper, .shopify-section-header, header[role="banner"]');
  if (header) {
    let lastScroll = 0;
    let scrollTicking = false;

    function updateHeader() {
      const currentScroll = window.pageYOffset;

      if (currentScroll > 80) {
        header.classList.add('pb-header--scrolled');
      } else {
        header.classList.remove('pb-header--scrolled');
      }

      // Hide on scroll down, show on scroll up (uniquement après 200px)
      if (currentScroll > lastScroll && currentScroll > 200) {
        header.classList.add('pb-header--hidden');
      } else {
        header.classList.remove('pb-header--hidden');
      }

      lastScroll = currentScroll;
      scrollTicking = false;
    }

    window.addEventListener('scroll', function () {
      if (!scrollTicking) {
        window.requestAnimationFrame(updateHeader);
        scrollTicking = true;
      }
    }, { passive: true });
  }

  // ─── COMPTEUR ANIMÉ (pour stats si présentes) ─────────
  const counters = document.querySelectorAll('[data-pb-counter]');
  if (counters.length) {
    const counterObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const target = parseInt(el.dataset.pbCounter, 10);
        const duration = parseInt(el.dataset.pbDuration || '1500', 10);
        const start = performance.now();
        const startVal = 0;

        function step(now) {
          const elapsed = now - start;
          const progress = Math.min(elapsed / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          const value = Math.floor(startVal + (target - startVal) * eased);
          el.textContent = value.toLocaleString('fr-FR');
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        counterObserver.unobserve(el);
      });
    }, { threshold: 0.3 });
    counters.forEach(function (c) { counterObserver.observe(c); });
  }

})();
